import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class HomeMapComponent {
    trigger = '[data-city]'
    slider

    constructor() {
        this.sliderCard().then(() => {
            if (window.matchMedia('(min-width: 1000px)').matches) {
                this.sliderActiveMarker()

                $(this.trigger).on('click', (e) => {
                    this.activeCity(e)
                })
            }
        })
    }

    activeCity(e) {
        const id = e.currentTarget.getAttribute('id')
        const slideTo = $(`[data-city-linked="${id}"]`).attr('data-city-index')
        this.slider.slideTo(slideTo)
    }

    sliderActiveMarker() {
        this.slider.on('slideChange', (e) => {
            $('[data-city]').removeClass('active')
            $(`[data-city][data-city-index="${e.activeIndex}"]`).addClass('active')
        })
    }

    async sliderCard() {
        const selector = '[data-element="home-map-slider"]'

        if ($(selector).length) {
            this.slider = await Swiper.create(selector, {
                slidesPerView: 1.05,
                mousewheel: {
                    forceToAxis: true,
                },
                autoplay: false,
                lazy: true,
                watchSlidesProgress: true,
                grabCursor: true,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.swiper__arrows__next',
                    prevEl: '.swiper__arrows__prev',
                },
                breakpoints: {
                    650: {
                        slidesPerView: 2,
                    },
                    1000: {
                        slidesPerView: 1,
                    },
                },
            })
        }
    }
}
